import React, { useCallback, useEffect, useMemo, useState } from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import LeftSidebar from "./left-sidebar";
import Navbar, { ContactUs } from "./navbar";
import { useResponsive } from "../hooks/use-media-query";
import { getActiveConId, getNotificationsCount } from "../redux/userSlice";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { getUid } from "../redux/authSlice";
import AllIcon from "../assets/icon/all-icon";
import Dialog from "../components/dialog/dialog";
import { Button } from "../components";
import { ChevronLeft, ChevronRight, East } from "@mui/icons-material";
import { child, get } from "firebase/database";
import { dbRef } from "../firebase/app";
import Notify from "../sections/notify/notify";
import NuroV2Banner from "./nuro-v2-banner";
import { SofiaV2LaunchProvider } from "./sofia-v2-launch-context";

interface CustomDrawerProps {
  customWidth?: string | number;
  open?: boolean;
}

const newFeatureItems = [
  { title: "Inbox", link: "inbox" },
  { title: "Calendar", link: "calendar" },
  { title: "Cartelligent", link: "cartelligent" },
  { title: "Report", link: "report" },
  { title: "Settings", link: "settings" },
];

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "customWidth",
})<CustomDrawerProps>(({ theme, open, customWidth }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    // width: drawerWidth,
    width: customWidth,
    borderRight: "none",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

export default function DashboardLayout({ children }: any) {
  const [showNewFeaturesModal, setShowNewFeaturesModal] = useState<boolean>(
    localStorage.getItem("seenNewFeatures") === "true" ? false : false
  );
  const [isActive, setIsActive] = useState(true);

  const uid = useSelector(getUid);
  const { isSmall, isWideDesktop, isUltraWideDesktop } = useResponsive();
  const activeConId = useSelector(getActiveConId);
  const location = useLocation();
  const currentRoute = location.pathname;

  const [open, setOpen] = useState(isWideDesktop);

  const notificationsCount = useSelector(getNotificationsCount);

  useEffect(() => {
    if (isWideDesktop) {
      const storageOpen = localStorage.getItem("sidebarOpen");
      if (!storageOpen || (storageOpen && storageOpen === "true")) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    } else {
      setOpen(false);
    }
  }, [isWideDesktop]);

  useEffect(() => {
    get(child(dbRef, `/dealers/${uid}/info/isActive`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setIsActive(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [uid]);

  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(!open);
    localStorage.setItem("sidebarOpen", open ? "false" : "true");
  };

  const renderLeftDrawer = (
    <>
      {isSmall && !activeConId && (
        <IconButton
          onClick={handleOpen}
          sx={{
            position: "absolute",
            top: "61px",
            left: "10px",
            zIndex: "1000",
            borderRadius: "8px",
          }}
        >
          <AllIcon />
          {notificationsCount > 0 && (
            <Box
              sx={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                backgroundColor: "red",
                position: "absolute",
                top: "0",
                right: "0",
                color: "white",
                fontSize: "10px",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* {cars?.length + appointments?.length > 9 ? "9+" : cars?.length + appointments?.length} */}
              {notificationsCount}
            </Box>
          )}
        </IconButton>
      )}
      {isSmall ? (
        <SwipeableDrawer
          anchor={"left"}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          keepMounted
          ModalProps={{
            keepMounted: true, // Better performance on mobile
          }}
          sx={{
            flexShrink: 0,
            width: "84px !important",
            minWidth: "84px !important",
            "& .MuiDrawer-docked .MuiDrawer-paper": {
              width: "84px !important",
            },
            "& .MuiDrawer-paper": {
              width: "300px",
              // backgroundColor: "#101C44",
              // background: "linear-gradient(120deg, #0C1635 -11.31%, #1E294C 58.09%)",
              backgroundColor: "#1D293D",
            },
          }}
          onBackdropClick={() => setOpen(false)}
        >
          {/* <Box sx={{ position: "fixed", width: "120px", left: "0" }}> */}
          {/* <Button onClick={handleOpen} sx={{ color: "red" }}>
            x
          </Button> */}

          <List
            component="nav"
            sx={{
              borderRight: "none",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              overflow: "auto",
            }}
          >
            <LeftSidebar openSidebar={open} setOpen={() => setOpen(false)} />
          </List>
          {/* </Box> */}
        </SwipeableDrawer>
      ) : (
        <Drawer
          variant="permanent"
          open={open}
          customWidth={isUltraWideDesktop ? "320px" : "256px"}
          sx={{
            // position: "absolute",

            height: "100dvh",
            // paddingTop: navHeight,
            // paddingTop: "70px",
            // backgroundColor: "#101C44",
            // background: "linear-gradient(120deg, #0C1635 -11.31%, #1E294C 58.09%)",
            backgroundColor: "#1D293D",
            zIndex: "200",
            "& .MuiDrawer-paper": {
              // backgroundColor: (theme: any) => theme.bg.paper,
              backgroundColor: "inherit",
              position: "relative",
              overflow: "visible",
            },
          }}
        >
          {isWideDesktop && (
            <IconButton
              onClick={handleOpen}
              sx={{
                backgroundColor: "#334155",
                width: "28px",
                height: "28px",
                color: "white",
                position: "absolute",
                right: "-14px",
                top: "16px",
                zIndex: "1000",
                "&:hover": {
                  backgroundColor: "#334155",
                },
              }}
            >
              {open ? (
                <ChevronLeft sx={{ fontSize: "18px" }} />
              ) : (
                <ChevronRight sx={{ fontSize: "18px" }} />
              )}
            </IconButton>
          )}
          <List
            component="nav"
            sx={{
              borderRight: "none",
              display: "flex",
              flexDirection: "column",
              height: "100dvh",
              justifyContent: "space-between",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "0",
            }}
          >
            <LeftSidebar openSidebar={open} />
          </List>
        </Drawer>
      )}
    </>
  );

  React.useEffect(() => {
    if (currentRoute === "/login") {
      if (uid) {
        navigate("/");
      } else {
        navigate("/login");
      }

      // return <PageLoading />;
    }
  }, [currentRoute, navigate, uid]);

  const handleNavigateToHelpCenter = useCallback(() => {
    localStorage.setItem("seenNewFeatures", "true");
    setShowNewFeaturesModal(false);
    navigate("/help-center");
  }, [navigate]);

  const renderContent = useMemo(
    () => (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}>
          {newFeatureItems.map((item) => (
            <Box
              key={item.title}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <Typography style={{ fontSize: "16px", fontWeight: "700" }}>{item.title}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    ),
    []
  );

  const renderActions = useMemo(
    () => (
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "8px" }}>
        <Button variant="outlined">Close</Button>
        <Button
          onClick={handleNavigateToHelpCenter}
          variant="contained"
          endIcon={<East sx={{ width: "14px" }} />}
        >
          Learn More
        </Button>
      </Box>
    ),
    [handleNavigateToHelpCenter]
  );

  return (
    <SofiaV2LaunchProvider>
      <Box
        sx={{
          display: "flex",
          // backgroundColor: (theme) => (isMobile ? theme.bg.paper : theme.bg.appBg),
          backgroundColor: (theme) => theme.bg.paper,
        }}
      >
        {renderLeftDrawer}
        <Box
          component="main"
          height={
            // isSmall ? (isMobile && activeConId ? "100dvh" : `calc(100dvh  - 64px)`) : `calc(100dvh)`
            "100dvh"
          }
          maxHeight="-webkit-fill-available"
          // margin={!isCustomLayout ? `0 0 0 0` : isMobile && activeConId ? "0" : `86px 0 0 0`}
          sx={{
            flexGrow: 1,
            position: "relative",
            // margin: isCustomLayout ? `${navHeightPx} 0 0 0` : `${navHeightPx} 0 ${bottomHeight} 0`,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          {isSmall && !activeConId && <Navbar />}
          <NuroV2Banner />
          <Stack
            flex={1}
            m={"auto"}
            // width={isMobile && activeConId ? "100%" : "98%"}
            width={"100%"}
            height={"100%"}
            sx={{
              marginTop: isSmall && !activeConId ? "64px" : "0",
              maxHeight: "calc(100dvh - 45px)",
            }}
          >
            <Stack
              sx={{
                m: "auto",
                width: "100%",
                height: "100%",
              }}
            >
              {children}
            </Stack>
          </Stack>
        </Box>
        {/* {isSmall && (!isMobile || (isMobile && !activeConId)) && <BottomNavigation />} */}
        <Dialog
          maxWidth="xs"
          customWidth={"500px"}
          open={showNewFeaturesModal}
          fullWidth
          handleClose={() => {
            localStorage.setItem("seenNewFeatures", "true");
            setShowNewFeaturesModal(false);
          }}
          renderTitle={"List of Update Feature"}
          renderContent={renderContent}
          renderActions={renderActions}
        />
        <ContactUs open={!isActive} />
        <Notify />
        {/* {activeFeatures.includes("supportInAllPages") && <LiveSupport />} */}
      </Box>
    </SofiaV2LaunchProvider>
  );
}
